/* eslint-disable import/no-duplicates */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/no-children-prop */
import React, { useEffect, useState, useMemo } from 'react';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  Modal,
  Typography,
} from '@mui/material';
import copy from 'copy-to-clipboard';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStyles from '../../../../assets/styles/pages/Request';
import Header from '../../../../components/Header';
import FooterMenuMain from '../../../../components/FooterMenuMain';

import { ReactComponent as IconInfo } from '../../../../assets/images/svg/utils/info.svg';
import { ReactComponent as IconImage } from '../../../../assets/images/svg/user/icon_image.svg';
import { ReactComponent as IconPDF } from '../../../../assets/images/svg/user/icon_pdf.svg';
import imagePreview from '../../../../assets/images/svg/user/icon_image.svg';

import { useLoadingContext } from '../../../../providers/use-loading';
import { useSignInContext } from '../../../../providers/use-signin';
import { ItypeReturnApi } from '../../../../helpers/utils/TypeReturnApi';
import { api } from '../../../../services';
import { getStorege } from '../../../../helpers/db_storage';

const styleModal = {
  position: 'absolute' as const,
  top: '100%',
  height: 850,
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  bgcolor: 'background.paper',
  border: '2px solid #ffffff',
  boxShadow: 24,
  p: 2,
  outline: 'none',
};

const UploadFilePix: React.FC = () => {
  const classeStyle = useStyles();
  const { createloading } = useLoadingContext();
  const { data, signingOut } = useSignInContext();
  let { id_request, id_shop }: any = useParams();
  const { success_order }: any = useParams();
  const navigate = useNavigate();

  id_request = window.atob(id_request);
  id_shop = window.atob(id_shop);

  const handleToPage = (url: string) => {
    return navigate(url, { replace: true });
  };
  const [openUserNotParams, setOpenUserNotParams] = useState(false);
  const [errorInfo, setErrorInfo] = useState('');
  const [imgReceiptPix, setImgReceiptPix] = useState<any>(null);
  const [dataRequest, setDataRequest] = useState<any>([]);
  const [openModalCopyPix, setOpenModalCopyPix] = useState(false);

  const previewImgReceiptPix: any = useMemo(() => {
    return imgReceiptPix ? URL.createObjectURL(imgReceiptPix) : null;
  }, [imgReceiptPix]);

  const handleChangeReceiptPixFile = (event: any) => {
    setImgReceiptPix(event.target.files[0]);
  };

  const getRequest = async () => {
    createloading(true);
    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.shop.getRequest({
        nr_operacao: 25,
        idUsuario: data.user?.idUsuario,
        idRestaurante: id_shop,
        idPedido: id_request,
        TipoRetorno: 2,
      });

      if (result.data?.detalhes.flgPix != 1) {
        toast.info('Pedido não encontrado.');
        handleToPage('/dashboard/user/request');
        return;
      }

      if (result.data?.detalhes.dsImagemCompPix) {
        toast.info('Comprovante já foi enviado!');
        handleToPage('/dashboard/user/request');
        return;
      }

      setDataRequest(result.data?.detalhes);
    } catch (error: any) {
      if (error.response.status === 401) {
        signingOut({
          http_status: 401,
          location: 'listAddress',
          id_shop: '',
        });
        toast.info('Sua sessão expirou, por favor faça login novamente');
      } else {
        toast.error('Ocorreu um erro ao buscar o pedido');
      }
    } finally {
      createloading(false);
    }
  };

  const handleCopyPix = async (key: string, openModal = true) => {
    copy(key);

    if (openModal) {
      setOpenModalCopyPix(true);
      return;
    }
    setOpenModalCopyPix(false);
    toast.success('Chave PIX copiada com sucesso!');
  };

  const handleUploadFile = async () => {
    if (!imgReceiptPix) {
      setOpenUserNotParams(true);
      setErrorInfo(
        'Ainda não foi anexado o comprovante. Sugerimos enviar o comprovante para que seu pedido seja efetivado o mais rapidamente. Você deseja enviar o pedido sem o comprovante mesmo assim?',
      );
      return;
    }
    createloading(true);
    const dataLocation = getStorege('@mais/delivery/dataStateCity');

    const dataFiles = new FormData();

    dataFiles.append('des_files', imgReceiptPix);
    dataFiles.append('nr_operacao', String(1));
    dataFiles.append('idRestaurante', String(id_shop));
    dataFiles.append('idPedido', String(id_request));
    dataFiles.append('idUsuario', String(data.user?.idUsuario));
    dataFiles.append('idOrigem', String(9));
    dataFiles.append('versaoApp', String('6.4.5'));
    dataFiles.append('dsCidade', String(dataLocation?.dsCidade));

    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.shop.uploadFile(
        dataFiles,
      );
      createloading(false);
      if (result.data?.retorno == 'OK') {
        toast.success('Comprovante enviado com sucesso!');
        handleToPage('/dashboard/user/request');
        return;
      }
      toast.error('Ocorreu um erro ao enviar o comprovante.');
      return;
    } catch (error) {
      createloading(false);
      toast.error('Ocorreu um erro ao enviar o comprovante.');
    }
  };

  useEffect(() => {
    if (data.user?.idUsuario) {
      getRequest();
    }
  }, [data.user]);

  useEffect(() => {
    if (success_order == 'true' && dataRequest?.dsChavePix) {
      setOpenModalCopyPix(true);
    }
  }, [success_order, dataRequest]);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="UserDetailRequestUploadFilePix" />

      <CssBaseline />
      <Grid
        container
        item
        justifyContent="center"
        alignItems="center"
        marginBottom="100px"
      >
        <Grid
          textAlign="center"
          justifyContent="center"
          className={classeStyle.gridTitleId}
        >
          <h5
            className={classeStyle.textTitleId}
            style={{ textTransform: 'uppercase' }}
          >
            Fazer o envio do comprovante do pix
          </h5>
        </Grid>
        <Grid>
          <p className={classeStyle.textInfoUploadFilePix}>
            É muito simples fazer o envio do comprovante, mas clicar no botão
            INSERIR COMPROVANTE, selecionar o comprovante do pix e clicar no
            botão ENVIAR.
          </p>
        </Grid>
        <Grid
          className={classeStyle.gridObservationMain}
          style={{ marginBottom: 40 }}
        >
          <Grid
            className={classeStyle.gridObservation}
            style={{ display: 'block', height: 350 }}
          >
            <h4
              className={classeStyle.titleObservation}
              style={{ textAlign: 'center', textTransform: 'uppercase' }}
            >
              Valor pix: R$ {dataRequest?.vlTotal}
            </h4>
            <Grid display="flex" justifyContent="center">
              {imgReceiptPix?.type == 'application/pdf' ? (
                <IconPDF width="100%" height="260px" />
              ) : (
                <img
                  className={classeStyle.imagePreview}
                  src={previewImgReceiptPix || imagePreview}
                  alt="image"
                />
              )}
            </Grid>
            <label
              htmlFor="input-file"
              id="uploadReceiptPix"
              className={classeStyle.uploadReceiptPix}
            >
              <input
                type="file"
                id="input-file"
                accept="image/*, application/pdf"
                onChange={handleChangeReceiptPixFile}
              />

              <p
                className={classeStyle.uploadReceiptpixInput}
                style={{ marginTop: 17 }}
                id="upload-foto-receiptpix-input"
              >
                <IconImage fill="#fff" className={classeStyle.iconImage} />
                {imgReceiptPix ? 'Alterar' : 'Inserir'} o comprovante
              </p>
            </label>
          </Grid>
          <hr className={classeStyle.hr} style={{ marginTop: 20 }} />
        </Grid>
        <Button
          className={classeStyle.btnSubmit}
          type="submit"
          variant="contained"
          style={{
            width: '80%',
            maxWidth: 550,
          }}
          onClick={handleUploadFile}
        >
          <p className={classeStyle.textBtnSubmit}>Enviar</p>
        </Button>
        <Button
          className={classeStyle.btnCopyPix}
          variant="contained"
          style={{
            width: '80%',
            maxWidth: 550,
          }}
          onClick={() => setOpenModalCopyPix(true)}
        >
          <p className={classeStyle.textBtnCopyPixUpload}>Copia chave pix</p>
        </Button>
      </Grid>
      <Modal
        open={openUserNotParams}
        onClose={() => setOpenUserNotParams(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...styleModal, height: '700px!important' }}>
          <Grid container item xs={12} justifyContent="center">
            <img style={{ width: 50 }} src={imagePreview} alt="image" />
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h3"
              style={{
                fontWeight: '550',
                width: '100%',
                textAlign: 'center',
                margin: 0,
                textTransform: 'uppercase',
              }}
            >
              Atenção!
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              className={classeStyle.textModal}
            >
              {errorInfo}
            </Typography>
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Button
              className={classeStyle.btnSubmit}
              style={{ width: '80%' }}
              onClick={() => handleToPage('/dashboard/user/request')}
              variant="contained"
            >
              SIM
            </Button>
            <Button
              style={{ width: '80%' }}
              onClick={() => setOpenUserNotParams(false)}
              variant="outlined"
            >
              NÃO
            </Button>
          </Grid>
        </Box>
      </Modal>
      <Modal
        open={openModalCopyPix}
        onClose={() => setOpenModalCopyPix(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...styleModal, top: '100%', height: '680px!important' }}>
          <Grid container item xs={12} justifyContent="center">
            <IconInfo className={classeStyle.iconModal} />
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              className={classeStyle.titleModal}
              style={{
                fontWeight: '550',
                width: '100%',
                textAlign: 'center',
              }}
            >
              Informação
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              style={{
                fontWeight: '500',
                width: '100%',
                color: '#a8a8a8',
                textAlign: 'center',
                marginTop: 5,
                marginBottom: 0,
              }}
            >
              Tipo da Chave PIX: <b>{dataRequest.tpChavePix}</b>
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              className={classeStyle.textModal}
            >
              Chave PIX: {dataRequest.dsChavePix}
            </Typography>
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Button
              className={classeStyle.btnSubmit}
              style={{ width: '80%' }}
              onClick={() => handleCopyPix(dataRequest.dsChavePix, false)}
              variant="contained"
            >
              COPIAR CHAVE PIX
            </Button>
            <Button
              style={{ width: '80%' }}
              onClick={() => setOpenModalCopyPix(false)}
              variant="outlined"
            >
              Fechar
            </Button>
          </Grid>
        </Box>
      </Modal>
      <FooterMenuMain children="Request" />
    </Container>
  );
};

export default UploadFilePix;
